import { postApi } from '../components/Utility'
import {
  action,
  makeObservable,
  observable
} from 'mobx';
import { message } from "antd";

class GeofenceVisitReportStore {

  total = 0
  geofenceVisitStore = []
  geofenceVisitSummary = []
  rootStore
  loading = false
  remaning_vehicleId = ""
  last_record_timestamp = ""
  pythonReportErrorMessage= false
  pythonReportMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      geofenceVisitStore: observable,
      geofenceVisitSummary: observable,
      loadData: action,
      loadGeofenceVisitSummary: action,
      loading: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage:observable
    });
    this.rootStore = rootStore;

  }


  async loadData({ companyId, filterBy, vehicleId, geoZoneId, fromDate, toDate, offset, limit,pageNo }) {
    this.loading = true
    
    var postData = {
      companyId: companyId,
      filterBy: filterBy,
      vehicleId: vehicleId,
      geoZoneId:geoZoneId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("/geofence_report/geofenceVisit", postData);
    // this.total = 500
    this.total = response?.data?.data?.TotalCount;
    this.geofenceVisitStore = response?.data?.data?.geofencevisit;
    this.geofenceData= response?.data?.data?.geofencevisit.map((items)=>items.tableData);
    // console.log(this.geofenceData)
    // this.total = response?.data?.data?.TotalCount;
    this.loading = false
  }


  async loadGeofenceVisitSummary({ vehicleId, date, companyId, filterBy, geoZoneId }) {
    this.loading = true;
    var postData = {
      vehicleId: vehicleId,
      date: date,
      companyId: companyId,
      filterBy: filterBy,
      geoZoneId: geoZoneId,
    };

    var response = await postApi.getClient().post("/geofence_report/geofenceVisitSummary", postData);

    this.geofenceVisitSummary = response?.data?.data;
    this.loading = false;
  }

  async exportExcel(getData) {
   
      getData = { ...getData, language: "english" }
      
      try {

        var response = await postApi.getClient().post("/geofence_report/geofenceVisit/download/excel", getData, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Geofence Visit Report.xlsx";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }
  }

  async exportpdf(getData) {
      getData = { ...getData, language: "english" }
     
      try {

        var response = await postApi.getClient().post("/geofence_report/geofenceVisit/download/pdf", getData, {
          responseType: "blob",
        });
  
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Geofence Visit Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }
  }
}

export default GeofenceVisitReportStore;
